import { useState } from 'react';
import { get as dig } from 'lodash';
import { useApolloClient } from '@apollo/client';

import GET_USERS_ASSIGNABLE_TO_TASK_LIST_QUERY from './getUsersAssignableToTaskList.graphql';

const PATH = 'viewer.usersAssignableToTaskList';

const usersFromData = (data) => dig(data, PATH, []).nodes;

const useSearchUsersAssignableToTaskList = () => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getUsersAssignableToTaskList = async (variables) => {
    setError(null);
    setLoading(true);
    try {
      const { data } = await client.query({
        query: GET_USERS_ASSIGNABLE_TO_TASK_LIST_QUERY,
        variables,
        fetchPolicy: 'network-only',
      });
      const hasMore = dig(data, `${PATH}.pageInfo.hasNextPage`, false);
      const endCursor = dig(data, `${PATH}.pageInfo.endCursor`, null);

      return {
        options: usersFromData(data),
        hasMore,
        additional: { endCursor },
      };
    } catch (e) {
      setError(e);
      return {
        options: [],
        hasMore: false,
        additional: {},
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    getUsersAssignableToTaskList,
    loading,
    error,
  };
};

export default useSearchUsersAssignableToTaskList;
